import { community } from '@/mocks/chaoyang';

const stats = [
  { num: '1200+', label: '累计速递现场', icon: 'ri-camera-3-line' },
  { num: '60+', label: '常驻片区观察员', icon: 'ri-eye-2-line' },
  { num: '38万+', label: '本地吃瓜瓜友', icon: 'ri-group-line' },
  { num: '15min', label: '现场平均响应', icon: 'ri-timer-flash-line' },
];

const roles = [
  'ri-play-circle-line',
  'ri-store-2-line',
  'ri-ball-pen-line',
  'ri-briefcase-line',
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-24 py-10 md:py-14">
      <div className="chigua-container">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="flex flex-col justify-center">
            <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-orange-500/10 px-3 py-1 text-xs font-bold text-orange-700 ring-1 ring-orange-500/20">
              <i className="ri-chat-smile-3-fill text-sm"></i>
              关于 · 瓜友口碑
            </span>
            <h2 className="mt-4 text-2xl font-black leading-snug tracking-tight text-stone-900 md:text-[32px]">
              朝阳吃瓜，把身边的
              <span className="text-orange-600">热瓜与现场</span>
              一网打尽
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-stone-600">
              朝阳吃瓜专注于北京朝阳及周边片区的本地热闻与新鲜见闻。我们不搬运遥远的标题党，而是更愿意跟着常驻各片区的观察员，把今天商场里、街头上、写字楼下真实发生的热闹事如实记录下来，再按「今日新瓜、现场速递、必看专题」整理成清晰的栏目，让你下班路上、午休间隙就能轻松追完全程。
            </p>
            <p className="mt-3 text-[15px] leading-relaxed text-stone-600">
              我们坚持几条朴素的原则：先说清信息能看到哪一步，不拿没核实的内容乱下结论；涉及隐私与肖像的细节主动脱敏；评论区留给真实看法而不是恶意攻讦。吃瓜图个新鲜，更要图个安心。
            </p>

            <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-2xl bg-white p-4 text-center ring-1 ring-orange-500/10">
                  <i className={`${s.icon} text-xl text-orange-500`}></i>
                  <p className="mt-2 text-xl font-black text-stone-900">{s.num}</p>
                  <p className="text-[11px] text-stone-500">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 content-start gap-4 sm:grid-cols-2">
            {community.map((c, i) => (
              <figure key={c.name} className="rounded-2xl bg-[#fff8ee] p-5 ring-1 ring-orange-500/10">
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-orange-500 to-red-500 text-sm font-black text-white">
                    {c.name.slice(0, 1)}
                  </span>
                  <figcaption className="min-w-0">
                    <p className="truncate text-sm font-bold text-stone-900">{c.name}</p>
                    <p className="flex items-center gap-1 text-[11px] text-stone-400">
                      <i className={`${roles[i % roles.length]} text-orange-400`}></i>
                      {c.role}
                    </p>
                  </figcaption>
                </div>
                <blockquote className="mt-3 text-[13px] leading-relaxed text-stone-600">“{c.content}”</blockquote>
                <p className="mt-3 flex items-center gap-1 text-[11px] font-medium text-stone-400">
                  <i className="ri-map-pin-2-line text-red-400"></i>
                  {c.loc}
                </p>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}